import React, {useState, useEffect} from 'react';
import { Link, useLocation } from "react-router-dom";

const NotificacionesNuevas = ({notificaciones}) => {
  const [notificacionesNuevas, setNotificacionesNuevas] = useState(false)

  useEffect(() => {
    const nuevas = notificaciones.filter(notificacion => (notificacion.estado === 'enviado' || notificacion.estado === 'para_enviar'))
    setNotificacionesNuevas(nuevas)
  }, [notificaciones]);

  const location = useLocation();

  const optionName = 'notificaciones'

  const optionHighlighted = () => {
    const statusOption = location.pathname.search(`/${optionName}/nuevas`) >= 0 ? 'active' : ''
    return `nav-link ${statusOption}`
  }

  return (
    <Link className={optionHighlighted()} to={`/${optionName}/nuevas`} >
      <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
        <svg width="12px" height="12px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
          <title>Notificaciones nuevas</title>
          <g stroke="none" strokeWidth="1" fill="none" >
            <g transform="translate(-1869.000000, -293.000000)" fill="#FFFFFF" >
              <g transform="translate(1716.000000, 291.000000)">
                <g id="office" transform="translate(153.000000, 2.000000)">
                  <path className="color-background opacity-6" d="M12.25,17.5 L8.75,17.5 L8.75,1.75 C8.75,0.78225 9.53225,0 10.5,0 L31.5,0 C32.46775,0 33.25,0.78225 33.25,1.75 L33.25,12.25 L29.75,12.25 L29.75,3.5 L12.25,3.5 L12.25,17.5 Z"></path>
                  <path className="color-background" d="M40.25,14 L24.5,14 C23.53225,14 22.75,14.78225 22.75,15.75 L22.75,38.5 L19.25,38.5 L19.25,22.75 C19.25,21.78225 18.46775,21 17.5,21 L1.75,21 C0.78225,21 0,21.78225 0,22.75 L0,40.25 C0,41.21775 0.78225,42 1.75,42 L40.25,42 C41.21775,42 42,41.21775 42,40.25 L42,15.75 C42,14.78225 41.21775,14 40.25,14 Z M12.25,36.75 L7,36.75 L7,33.25 L12.25,33.25 L12.25,36.75 Z M12.25,29.75 L7,29.75 L7,26.25 L12.25,26.25 L12.25,29.75 Z M35,36.75 L29.75,36.75 L29.75,33.25 L35,33.25 L35,36.75 Z M35,29.75 L29.75,29.75 L29.75,26.25 L35,26.25 L35,29.75 Z M35,22.75 L29.75,22.75 L29.75,19.25 L35,19.25 L35,22.75 Z"></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <span className="nav-link-text ms-1">Nuevas <span className='badge text-bg-warning'>{notificacionesNuevas.length}</span></span>
    </Link>
  );
};

export default NotificacionesNuevas;